import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { blogs } from './BlogData';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import { IoIosArrowForward } from 'react-icons/io';
import axios from 'axios';
import { FaHome } from 'react-icons/fa';


interface NewsStructure {
  id:string;
  title:string;
  img:string;
  content:string;
  date:string;
  RMBiansOfMeeting :number;
  Presentation_Second:number;
  Presentation_First:number;
  Gallery:string;
}

interface MeetingUser{
  id:string;
  name:string;
  desgination:string;
  profile:string;
}
type BlogDetailsProps = {
  title: string;
};

const BlogDetails: React.FC = () =>{
  const api = process.env.REACT_APP_API_URL as string;
  
  const [newData, setNewData] = useState<NewsStructure[]>([]);
  const [userDataRmbian, setUserDataRmbain] = useState<MeetingUser[]>([]);
  const [userDataPresentFirst, setUserDataPresentfirst] = useState<MeetingUser[]>([]);
  const [userDataPresentSecond, setUserDataPresentSecond] = useState<MeetingUser[]>([]);
  const { title } = useParams<{ title: string }>();
  const decodedTitle = title ? decodeURIComponent(title) : '';
  
  // //console.log('sending title is : ', decodedTitle);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(
          `${api}/auth/news/title/${decodedTitle}`
        );

        // //console.log('news data',response.data)
        setNewData(response.data);
        // //console.log("news data in a array",newData);
      } catch (error) {
        // console.error("Post Not Found:", error);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const fetchAllData = async () => {
      try {
        // Filter `newData` based on non-zero values
        const RMBians = newData.filter((data) => data.RMBiansOfMeeting !== 0);
        const PresentationSecond = newData.filter((data) => data.Presentation_Second !== 0);
        const PresentationFirst = newData.filter((data) => data.Presentation_First !== 0);

        // Fetch data
        const RMBiansPromises = RMBians.map((data) =>
          axios.get<MeetingUser[]>(`${api}/auth/user/${data.RMBiansOfMeeting}`)
        );
        const PresentationSecondPromises = PresentationSecond.map((data) =>
          axios.get<MeetingUser[]>(`${api}/auth/user/${data.Presentation_Second}`)
        );
        const PresentationFirstPromises = PresentationFirst.map((data) =>
          axios.get<MeetingUser[]>(`${api}/auth/user/${data.Presentation_First}`)
        );

        // Wait for all API calls
        const RMBiansData = await Promise.all(RMBiansPromises);
        const PresentationSecondData = await Promise.all(PresentationSecondPromises);
        const PresentationFirstData = await Promise.all(PresentationFirstPromises);

        // Update state
        setUserDataRmbain(RMBiansData.flatMap((res) => res.data));
        setUserDataPresentfirst(PresentationFirstData.flatMap((res) => res.data));
        setUserDataPresentSecond(PresentationSecondData.flatMap((res) => res.data));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (newData && newData.length > 0) {
      fetchAllData();
    }
  }, [newData]);
 
 

  return (
    <div>

    
    <Header/>
    {newData.map((data)=>(
      <div
              className="w-full h-[451px] relative"
              style={{
                backgroundImage: `url(${api}/uploads/Connect,_Collaborate_And_Succeed.png)`,
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            >
              {/* <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div> */}
              <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
                <h2 className=" text-center sm:text-[31px] text-[48px] text-[#FDBC12] font-bold ">
                  {data.title}{" "}
                </h2>
                <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
                  {data.content.substring(0,230)}
                </p>
                
              </div>
            </div>
    ))}

      <div className="bg-[#1E2A3A] py-14 px-[8%] flex flex-wrap  gap-y-8 w-[100%] border-b border-[#465468]">
      {newData.map((items)=>(
           <div className="lg:w-[48%] w-[100%] pr-5">
           <h2 className="text-[#FDBC12] text-[39px] font-semibold ">
             Meetings
           </h2>
          
           <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
             {items.title}
           </p>
           <ol className="list-decimal text-[#94A2B8] text-[400] ml-4 mt-4 flex flex-col gap-y-4">
            {items.content.split('</br>').map((list)=>(
             <li>{list}</li>
            ))}
           </ol>
         </div> 
          ))}
        
        <div className="lg:w-[48%] w-[100%]">
        {newData.map((item, outerIndex) => (
  <div key={`gallery-item-${outerIndex}`}>
    {item.Gallery.split('&').map((img, innerIndex) => (
      <div
        key={`gallery-image-${outerIndex}-${innerIndex}`}
        className={`w-[100%] flex ${
          innerIndex % 2 === 0 ? 'justify-end' : 'justify-start'
        } mt-5`}
      >
        <img
          className="w-[60%]"
          src={`${api}/${img}`}
          alt={`Gallery Image ${outerIndex}-${innerIndex}`}
        />
      </div>
    ))}
  </div>
))}


        </div>
      </div>
      <div className="bg-[#101729] py-14 px-[8%] flex flex-wrap w-[100%] border-b border-[#465468] ">
        {newData.map((item)=>(
          <div className="md:w-[55%] w-[100%]">
          <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
          Presentation Details
          </p>
          <ul className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
            {item.content.split('</br>').map((list)=>(
              <li>
              {list}
            </li>

            ))}
            
            
          </ul>
        </div>
        ))}

{userDataRmbian.map((item)=>(
           <div className="md:w-[45%] w-[100%] flex md:pl-[60px] md:mt-0 mt-5">
           <div className="w-[1px] h-[156px] bg-[#D9D9D9] mt-5"></div>
           <div className="pl-[80px]">
             <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
              Presentation By
             </p>
             <p className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
              {item.name}
              
             </p>
           </div>
         </div>
        ))}        
       
      </div>
      {userDataPresentFirst.map((items)=>(
        <div className="bg-[#101729] py-14 px-[8%] flex flex-wrap w-[100%] border-b border-[#465468]">
        <div className="w-[1px] h-[156px] bg-[#D9D9D9] mt-5"></div>
        <div className="pl-[80px]">
          <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
           Presentation 1
          </p>
          <p className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
           {items.name}
           
          </p>
        </div>
      </div>
      ))}
      
      {userDataPresentSecond.map((items)=>(
        <div className="bg-[#101729] py-14 px-[8%] flex flex-wrap w-[100%] border-b border-[#465468]">
        <div className="w-[1px] h-[156px] bg-[#D9D9D9] mt-5"></div>
        <div className="pl-[80px]">
          <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
           Presentation By
          </p>
          <p className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
           {items.name}
           
          </p>
        </div>
      </div>
      ))}
   
    <Footer/>
    </div>
  );
};

export default BlogDetails;
